import React from 'react'
import styles from "../Fees/Fees.module.scss";

const PrivacyPolicy = () => {
    return (
        <div className={styles.fee_content}>
            <div className={styles.legal_header}>
                <h1>STBL Privacy Policy</h1>
        
            </div>

            <div className={styles.legal_section}>
                <h3>1. Introduction <span>Policy</span></h3>
                <p>STBL, LLC (“STBL,” “we,” “our,” or “us”) operates the STBL platform accessible via user.stbl.io (the “Platform”). This Privacy Policy describes how we collect, use, and safeguard your information. By creating an account or using the Platform, you consent to the practices described below.</p>
            </div>

            <div className={styles.legal_section}>
                <h3>2. Information We Collect <span>Data</span></h3>
                <p>We collect the following categories of information to provide our services and comply with legal obligations:</p>
                <ul>
                    <li><strong>Identity:</strong> Full legal name, DOB, address, government-issued ID.</li>
                    <li><strong>Contact:</strong> Email address, phone number.</li>
                    <li><strong>Financial:</strong> Bank details, wallet addresses, transaction history.</li>
                    <li><strong>Technical:</strong> IP address, device info, browser type, access logs.</li>
                </ul>
            </div>

            <div className={styles.legal_section}>
                <h3>3. How We Use Your Information <span>Usage</span></h3>
                <p>Your data is used to verify identity (KYC/AML), prevent fraud, process transactions, and maintain the Platform’s security and functionality.</p>
            </div>

            <div className={styles.legal_section}>
                <h3>4. Sharing of Information <span>Sharing</span></h3>
                <p>We share data with KYC providers, banking partners, and regulatory authorities as necessary. We do not sell your personal data.</p>
            </div>

            <div className={styles.legal_section}>
                <h3>5. Data Security <span>Security</span></h3>
                <p>We implement commercially reasonable safeguards including encryption in transit and secure storage practices.</p>
            </div>

            <div className={styles.legal_section}>
                <h3>6. Your Rights <span>Rights</span></h3>
                <p>Depending on your jurisdiction, you may have the right to access, correct, or request deletion of your data. Requests can be submitted to: <strong>support@stbl.io</strong></p>
            </div>

            <div className={styles.legal_footer}>
                <p>We may update these policies from time to time. Changes will be posted on this page, and continued use of the Platform constitutes acceptance of the updated Terms.</p>
            </div>
        </div>
    )
}

export default PrivacyPolicy
